import { cn } from "@/lib/utils";
import { memo } from "react";

export type ProcessCardProps = {
  title?: string;
  index?: number;
  description?: string;
  url?: string;
} & React.ComponentProps<"div">;

const ProcessCard = ({
  index,
  title,
  description,
  className,
}: ProcessCardProps) => {
  return (
    <div className={cn("flex", className)}>
      {!!index && (
        <span className="w-12 h-12 mr-4 lg:mr-6 rounded-full shrink-0 bg-blue p-1 inline-flex items-center justify-center text-xl leading-0 text-white">
          {index}
        </span>
      )}
      <div className="flex-auto min-w-0 grid grid-cols-1 place-content-start gap-2 lg:gap-3">
        {!!title && (
          <h3 className="text-xl leading-[120%] font-medium lg:leading-[150%]">
            {title}
          </h3>
        )}
        {!!description && (
          <p className="text-semantic-text-primary lg:text-gray-500 text-base leading-[160%] lg:text-sm lg:leading-[150%]">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default memo(ProcessCard);
